export const handleApiResponseOrThrow = async response => {
    if(!response.ok) {
        const errorBody = await response.json()
        throw new Error(errorBody?.reason)
    }
    return response.json()
}